/* eslint semi:0 */
import BaseVm from 'vms/BaseVm'
import { isMobile, isTablet, } from 'utils/ua'
import { wrapButtonInLabel, } from 'views/ButtonView'
import socialButtonsConf from 'config/socialButtonsConfig'
import { MOUNT_POINTS, } from 'config/preRenderedSelectorsConfig'
import { isSupportedForDomain, } from 'application/pageDataObject'


export default class SocialButtonsBaseVm extends BaseVm {

  filterByExcludedFeatureId({ featureId, }){
    if (!featureId) {
      return true
    }
    return isSupportedForDomain(featureId)
  }

  getVisibleButtons(){
    const { shouldRenderButtons, isBottomComponent, } = this
    if (!shouldRenderButtons) {
      return []
    }
    const {
      facebook, twitter, whatsapp, embed, comments,
    } = socialButtonsConf
    const baseSocialSharingButtons = [facebook, twitter, ]
    let result = [...baseSocialSharingButtons, embed, comments, ]
    if (isTablet) {
      result = [...baseSocialSharingButtons, comments, ]
    } else if (isMobile) {
      result = [...baseSocialSharingButtons, whatsapp, ]
      if (isBottomComponent) {
        result.push(comments)
      }
    }
    const visibleButtons = result.filter(this.filterByExcludedFeatureId)
    if (isBottomComponent) {
      return visibleButtons.map(wrapButtonInLabel)
    }
    return visibleButtons
  }

  get shouldRenderButtons(){
    throw Error("should be overriden")
  }

  get isBottomComponent(){
    return this.options.rootSelector === MOUNT_POINTS.FOOTER_SOCIAL_ICONS
  }

}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/socialButtons/SocialButtonsBaseVm.js